import { render, staticRenderFns } from "./BSearchSelect.vue?vue&type=template&id=16db1b3f&scoped=true&"
import script from "./BSearchSelect.vue?vue&type=script&lang=js&"
export * from "./BSearchSelect.vue?vue&type=script&lang=js&"
import style0 from "./BSearchSelect.vue?vue&type=style&index=0&id=16db1b3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_react-dom@18_vyrjir3tafa6d7xmeapelwsujq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db1b3f",
  null
  
)

export default component.exports